export const SET_USER = 'SET_USER';
export const SELECT_COUNTER = 'SELECT_COUNTER';
export const SELECT_ADDRESS = 'SELECT_ADDRESS';
export const SELECT_BOOKMARKS = 'SELECT_BOOKMARKS';
export const SELECT_WISHES = 'SELECT_WISHES';

export const TOGGLE_LIKE_POST = 'TOGGLE_LIKE_POST';
export const TOGGLE_BOOKMARK_POST = 'TOGGLE_BOOKMARK_POST';
export const TOGGLE_BOOKMARK_PRODUCT = 'TOGGLE_BOOKMARK_PRODUCT';
